module.exports = __webpack_public_path__ + "static/media/swmlogo2.4d85d910.png";